import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_NEW_ROLE_LIST,
  SET_NEW_ROLE_PAGE_STATUS,
  SET_NEW_ROLE_CONFIG_MODAL_DATA,
  SET_ADD_USER_CONFIG_MODAL_DATA,
  GET_USER_LIST,
  GET_ROLE_PERMIT,
  DELETE_NEW_ROLE,
  SET_NEW_ROLE,
  SET_USER_BINDING,
  SET_NEW_ROLE_SEARCHDATA,
} = SYSTEMSETTING;
// 通用前缀
const url = '/robot';

const actions = {
  // 系统设置-角色管理-列表
  getTableList(data) {
    return {
      type: GET_NEW_ROLE_LIST,
      payload: {
        request: {
          method: 'get',
          url: `${url}/permit/role/list?pageSize=${data.pageSize}&pageNum=${
            data.pageNum
          }&name=${data.name}`,
          data,
        },
      },
    };
  },
  // 系统设置-角色管理-用户列表
  getUserList(data) {
    return {
      type: GET_USER_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/permit/role/application/userList`,
          data,
        },
      },
    };
  },
  // 系统设置-角色管理-角色权限
  getRolePermit(data) {
    return {
      type: GET_ROLE_PERMIT,
      payload: {
        request: {
          method: 'get',
          url: `${url}/permit/role?roleId=${data.roleId}`,
        },
      },
    };
  },
  // 系统设置-角色管理-删除
  deleteRole(data) {
    return {
      type: DELETE_NEW_ROLE,
      payload: {
        request: {
          method: 'delete',
          url: `${url}/permit/role`,
          data,
        },
      },
    };
  },
  // 系统设置-角色管理-获取添加角色弹框的数据
  setNewRoleData(data) {
    return {
      type: SET_NEW_ROLE,
      payload: {
        request: {
          method: 'get',
          url: `${url}/permit/role?roleId=${data.roleId}`,
        },
      },
      data,
    };
  },
  // 系统设置-角色管理-角色绑定用户
  setUserBinding(data) {
    return {
      type: SET_USER_BINDING,
      payload: {
        request: {
          method: 'post',
          url: `${url}/permit/userBinding/${data.roleId}`,
          data,
        },
      },
    };
  },
  // 系统设置-角色管理-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_NEW_ROLE_PAGE_STATUS,
      data,
    };
  },
  // 系统设置-角色管理-设置pageNum与pageSize
  setSearchData(data) {
    return {
      type: SET_NEW_ROLE_SEARCHDATA,
      data,
    };
  },
  // 系统设置-角色管理-新增编辑角色确认
  setNewRole(data) {
    return {
      type: SET_NEW_ROLE_CONFIG_MODAL_DATA,
      payload: {
        request: {
          method: 'post',
          url: `${url}/permit/role?roleId=${data.roleId}`,
          data,
        },
      },
    };
  },
  // 系统设置-角色管理-获取用户弹框的数据
  setAddUserData(data) {
    return {
      type: SET_ADD_USER_CONFIG_MODAL_DATA,
      data,
    };
  },
};

export default actions;
